import LinkIcon from '@/app/icons/link'
import { isKoddiApiAdGif } from '@/app/util/ads-util'
import { addNoFreestarParam } from '@/util/url'
import { IGif } from '@giphy/js-types'
import { getContentOfGif, getCreatorOfGif, setGADataLayer } from 'analytics'
import { useContext } from 'react'
import { ShareUrlRenditions } from 'utils/src/media/sharing'
import { getShareUrl } from 'utils/src/url'
import { FlashMessageContext } from '../../../context/flash-message'

type Props = {
    gif: IGif
    isClip?: boolean
}

const ClipboardButton = ({ gif, isClip = false }: Props) => {
    const { showMessage } = useContext(FlashMessageContext)
    const {
        url,
        images: {
            original: { url: mediaUrl },
        },
    } = gif
    const shareUrl = isClip ? url : getShareUrl(mediaUrl)
    const clipboardUrl = isKoddiApiAdGif(gif) ? addNoFreestarParam(shareUrl) : shareUrl
    return (
        <LinkIcon
            className="size-5 fill-giphyWhite transition-transform hover:scale-125"
            onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                navigator.clipboard.writeText(clipboardUrl)
                showMessage({ message: 'Link copied to clipboard!', type: 'success' })
                setGADataLayer({
                    event: 'share_success',
                    options: {
                        social: {
                            socialChannel: 'share',
                        },
                        content: getContentOfGif(gif, {
                            rendition: ShareUrlRenditions.Original,
                            format: gif.images.original.url,
                        }),
                        creator: getCreatorOfGif(gif),
                    },
                })
            }}
        />
    )
}

export default ClipboardButton
